import { render, staticRenderFns } from "./WomenPage.vue?vue&type=template&id=067633f6&scoped=true&"
import script from "./WomenPage.vue?vue&type=script&lang=js&"
export * from "./WomenPage.vue?vue&type=script&lang=js&"
import style0 from "./WomenPage.vue?vue&type=style&index=0&id=067633f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067633f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
